export const BULK_PAYOUT_UPLOAD_LIST_URL =
  "/scheme-planning/ims/manualUpload/getStatus/programManualUploadListing?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const BULK_PAYOUT_SAVE_CSV_URL =
  "/scheme-planning/ims/manualUpload/import/programManualUpload";
export const BULK_PAYOUT_EXCEL_URL =
  "/scheme-planning/ims/manualUpload/export/programManualTemplate";
export const BULK_PAYOUT_ERROR_EXCEL_URL =
  "/scheme-planning/ims/manualUpload/errorFile/programManualUpload?{manualUploadHdrIds}";
export const GET_FAILED_FILES_LIST_URL =
  "/scheme-planning/ims/manualUpload/getFailedFileDetail";
export const GET_FAILED_FILES_DOWNLOAD_CSV_URL =
  "/scheme-planning/ims/error/file?fileNameWithExt={fileNameWithExt}";
export const GET_RELEASED_PLANS_LIST_URL = 
  "/scheme-planning/ims/manualUpload/getApprovedPlans?planNo={plan}";
export const SAVE_RELEASED_PLANS_URL = 
"/scheme-planning/ims/manualUpload/releaseApprovedPlans";
